const clientReducer = (state = null, action) => {
  switch (action.type) {
    case "LOGIN":
    case "SET_DATA":
      return action.payload;

    case "LOGOUT":
      return null;

    default:
      return state;
  }
};

export default clientReducer;
